import React from 'react';
import NewForm from '../../../components/forms/StudentForm/NewForm';

export default function StudentsCreatePage() {
  return <NewForm />;
}
